var gini = /** @class */ (function () {
    function gini() {
    }
    gini.STORE_MODULE_NAME = 'gini';
    return gini;
}());
export { gini };



//////////////////
// WEBPACK FOOTER
// ./src/plugins/Gini/lib/gini.cls.ts
// module id = null
// module chunks = 